import React from 'react';

const StatCard = ({ title, value, subtext, highlight = false }) => {
  return (
    <div className={`p-6 rounded-2xl border backdrop-blur-md transition-all ${
      highlight 
        ? 'bg-red-500/10 border-red-500/30 shadow-[0_0_25px_rgba(239,68,68,0.15)]'
        : 'bg-white/[0.03] border-white/10'
    }`}>
      <h3 className="text-white/60 text-sm font-medium tracking-wide mb-2 uppercase">{title}</h3>
      <div className={`text-4xl font-bold font-mono tracking-wider ${highlight ? 'text-red-400' : 'text-white'}`}>
        {value}
      </div>
      {subtext && (
        <div className="text-white/40 text-xs mt-3 uppercase tracking-widest">{subtext}</div>
      )}
    </div>
  );
};

export default StatCard;
